module.exports = __webpack_public_path__ + "static/media/logo2.fd86b791.png";